import styled, { keyframes } from "styled-components";
import breakpoints from "../../../../constants/breakpoints";

const heartFlyToTop = keyframes`
  to {
    transform: translate(-50%, calc(-50% - 80px)) rotate(-45deg);
    opacity: 0;
  }
`;

export const Styles = styled.div`
  .flying-heart {
    position: fixed;
    left: var(--fly-x);
    top: var(--fly-y);
    transform: translate(-50%, -50%);
    color: var(--main-color);
    font-size: 1.25rem;
    pointer-events: none;
    z-index: 9999;
    animation: ${heartFlyToTop} 1.2s ease-in-out forwards;
  }

  .donation-form {
    background: white;
    border-radius: ${({ $isInDetailsPage }) => ($isInDetailsPage ? "0" : "8px")};
    padding:  ${({ $isInDetailsPage }) => ($isInDetailsPage ? "0.5rem 2rem 1.5rem" : "2rem")};;;
    box-shadow: ${({ $isInDetailsPage }) => ($isInDetailsPage ? "none" : "0 2px 8px rgba(0, 0, 0, 0.1)")};

    .main-title {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      margin-bottom: 1.5rem;
      img {
        width: 24px;
        height: 24px;
      }
      span {
        font-size: 1.25rem;
        font-weight: 600;
      }
    }

    .donation-type-toggle {
      display: flex;
      margin-bottom: 1.5rem;
      border: 2px solid #e2e8f0;
      border-radius: var(--border-radius);
      background: var(--white);

      button {
        flex: 1;
        padding: 0.75rem 1rem;
        border: none;
        background: transparent;
        font-size: 1rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        color: var(--dark-grey);
        border-radius: var(--border-radius);

        svg {
          color: var(--main-color);
        }

        &.active {
          color: var(--main-color);
          box-shadow: 0 0 0 2px var(--main-color);
          background: #f7fafc;
        }
      }
    }

    .monthly-login-message {
      text-align: center;
      color: #4a5568;
      font-size: 1rem;
      margin: 1.5rem 0 1rem;
      line-height: 1.5;
    }

    .support-text {
      text-align: center;
      font-size: 0.875rem;
      color: var(--dark-grey);
      margin-bottom: 1.5rem;
    }

    .amount-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 0.75rem;
      margin-bottom: 1.5rem;

      .amount-btn {
        padding: 0.75rem;
        border: 2px solid #e2e8f0;
        background: white;
        border-radius: 6px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        color: #2d3748;

        &:hover {
          border-color: #cbd5e0;
          background: #f7fafc;
        }

        &.selected {
          background: var(--main-color);
          border-color: var(--main-color);
          color: white;
        }
      }
    }

    .amount-error-message {
      color: var(--danger, #dc3545);
      font-size: 0.875rem;
      margin: -0.5rem 0 0.75rem;
    }

    .custom-amount-section {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 1rem;
      border: 2px solid #e2e8f0;
      border-radius: 6px;
      padding: 0.5rem 1rem;
      background: white;

      &:focus-within {
        border-color: var(--main-color);
      }

      .currency-symbol {
        font-size: 1.25rem;
        font-weight: 600;
        color: #2d3748;
      }

      .custom-amount-input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 1.5rem;
        font-weight: 600;
        color: #2d3748;
        padding: 0.5rem;
        width: 100%;

        &::placeholder {
          color: #cbd5e0;
        }

        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }

      .currency-select {
        border: none;
        outline: none;
        font-size: 1rem;
        font-weight: 500;
        color: var(--dark-grey);
        background: transparent;
        cursor: pointer;
        padding: 0.5rem;
      }
    }

    .dedicate-checkbox {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 1rem;

      input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
        accent-color: var(--main-color);
      }

      label {
        font-size: 0.875rem;
        color: var(--dark-grey);
        cursor: pointer;
      }
    }
  }

  @media (max-width: ${breakpoints.md}) {
    .donation-form {
      padding: 1.5rem;
      .amount-grid {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    .donation-form {
      .custom-amount-section {
        .custom-amount-input {
          font-size: 1.25rem;
        }
      }
    }
  }
`;
